import type { SVGProps } from 'react';
const SvgError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Error_svg__a)">
      <path
        d="M9.008 1.628a1.124 1.124 0 0 0-2.017 0L1.097 13.636A.946.946 0 0 0 1.947 15h12.106a.945.945 0 0 0 .85-1.364z"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <path
        d="M8.75 6a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zM8 13a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="Error_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgError;
